import { ECode } from "~/_enums/ECode";
import { TApiConfig } from "~/_libs/fetch/fetchConfig";
import { fetchPostJson } from "~/_libs/fetch/fetchPostJson";

type TPostAuthConnectRequestsOutputDto = {
  code: ECode;
  data: {
    id: string;
    key: string;
  };
};

/** 인증 요청 생성 */
export const postAuthConnectRequests = (
  config: TApiConfig,
): Promise<TPostAuthConnectRequestsOutputDto> =>
  fetchPostJson("/auth/connect/requests", {}, config);
